import type { WindowsFields } from '../types/wizard.types';
import { maskMoney, parseMoney } from './masks';

/** Строки таблицы п. 3.4 раздельного договора купли-продажи. */
export const KP_BREAKDOWN_KEYS = [
  'constructionsAmount',
  'garbageRemovalAmount',
] as const satisfies ReadonlyArray<keyof WindowsFields>;

/** Строки таблицы п. 1.3 договора подряда. */
export const PODRYAD_BREAKDOWN_KEYS = [
  'workDemontage',
  'workInstallation',
  'workSlopes',
  'workFlashings',
  'workAdditional',
] as const satisfies ReadonlyArray<keyof WindowsFields>;

/** Строки 2–7 таблицы п. 3.4 объединённого договора на окна. */
export const UNITED_BREAKDOWN_KEYS = [
  'constructionsAmount',
  'slopesAmount',
  'deliveryAmount',
  'workInstallation',
  'workSlopes',
  'workAdditional',
] as const satisfies ReadonlyArray<keyof WindowsFields>;

export function sumKpBreakdown(
  windows: Pick<WindowsFields, (typeof KP_BREAKDOWN_KEYS)[number]>,
): number {
  return KP_BREAKDOWN_KEYS.reduce((sum, key) => sum + parseMoney(windows[key]), 0);
}

export function formatKpTotal(
  windows: Pick<WindowsFields, (typeof KP_BREAKDOWN_KEYS)[number]>,
): string {
  const total = sumKpBreakdown(windows);
  if (total <= 0) return '';
  return maskMoney(total.toFixed(2).replace('.', ','));
}

export function sumPodryadBreakdown(
  windows: Pick<WindowsFields, (typeof PODRYAD_BREAKDOWN_KEYS)[number]>,
): number {
  return PODRYAD_BREAKDOWN_KEYS.reduce((sum, key) => sum + parseMoney(windows[key]), 0);
}

export function formatPodryadTotal(
  windows: Pick<WindowsFields, (typeof PODRYAD_BREAKDOWN_KEYS)[number]>,
): string {
  const total = sumPodryadBreakdown(windows);
  if (total <= 0) return '';
  return maskMoney(total.toFixed(2).replace('.', ','));
}

export function sumUnitedBreakdown(
  windows: Pick<WindowsFields, (typeof UNITED_BREAKDOWN_KEYS)[number]>,
): number {
  return UNITED_BREAKDOWN_KEYS.reduce((sum, key) => sum + parseMoney(windows[key]), 0);
}

export function formatUnitedTotal(
  windows: Pick<WindowsFields, (typeof UNITED_BREAKDOWN_KEYS)[number]>,
): string {
  const total = sumUnitedBreakdown(windows);
  if (total <= 0) return '';
  return maskMoney(total.toFixed(2).replace('.', ','));
}

export function sumKpBreakdownNumbers(windows: {
  constructionsAmount: number;
  garbageRemovalAmount: number;
}): number {
  return windows.constructionsAmount + windows.garbageRemovalAmount;
}

export function sumPodryadBreakdownNumbers(windows: {
  workDemontage: number;
  workInstallation: number;
  workSlopes: number;
  workFlashings: number;
  workAdditional: number;
}): number {
  return (
    windows.workDemontage
    + windows.workInstallation
    + windows.workSlopes
    + windows.workFlashings
    + windows.workAdditional
  );
}

export function sumUnitedBreakdownNumbers(windows: {
  constructionsAmount: number;
  slopesAmount: number;
  deliveryAmount: number;
  workInstallation: number;
  workSlopes: number;
  workAdditional: number;
}): number {
  return (
    windows.constructionsAmount
    + windows.slopesAmount
    + windows.deliveryAmount
    + windows.workInstallation
    + windows.workSlopes
    + windows.workAdditional
  );
}
